var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-2 py-2 border border-black",attrs:{"elevation":"0"}},[_c('div',{staticClass:"d-flex align-center"},[_vm._t("icon"),_c('div',{staticClass:"text-h6 font-weight-bold ml-2 color-custom-blue"},[_vm._t("title")],2)],2),_c('v-divider',{staticClass:"mt-2 mb-0"}),_c('div',{staticClass:"mt-2"},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }